// This file is automatically generated from ingestAssets.mjs
import * as React from 'react';
import IconContainer, { IconProps } from '../../../components/IconContainer';

export function ChatIcon(props: IconProps) {
	return (
		<IconContainer {...props}>
			{
				<svg
					xmlns="http://www.w3.org/2000/svg"
					width="100%"
					height="100%"
					fill="none"
					viewBox="0 0 32 32"
				>
					<path
						fill="currentColor"
						d="M17.125 15.997a1.125 1.125 0 1 1-2.25 0 1.125 1.125 0 0 1 2.25 0Zm-5.25-1.125a1.125 1.125 0 1 0 0 2.25 1.125 1.125 0 0 0 0-2.25Zm8.25 0a1.125 1.125 0 1 0 0 2.25 1.125 1.125 0 0 0 0-2.25Zm5.625 1.125a9.75 9.75 0 0 1-14.332 8.608L8.225 25.67a1.5 1.5 0 0 1-1.897-1.897l1.064-3.193a9.75 9.75 0 1 1 18.358-4.582Zm-1.5 0a8.25 8.25 0 1 0-15.393 4.13.75.75 0 0 1 .062.614L7.75 24.247l3.506-1.17a.734.734 0 0 1 .612.063 8.25 8.25 0 0 0 12.382-7.143Z"
					/>
				</svg>
			}
		</IconContainer>
	);
}
